<div style="padding:5px">
    <h4>
        {{ title }}
    </h4>


    @for (link of links; track link) {
        <div class="mb-1">
            <a href="{{ link.link }}">{{ link.descr }}</a>
        </div>
    }
</div>